
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.38.692h4.049v5.453c6.823 0 13.645.014 20.468-.02 1.152.047 2.42-.034 3.421.654.702 1.009.62 2.29.668 3.449-.033 11.832-.02 23.658-.013 35.483-.033 1.984.184 4.008-.231 5.964-.273 1.418-1.977 1.452-3.116 1.5-7.06.02-14.129-.014-21.197 0v6.134h-4.233C20.81 57.421 10.4 55.676 0 53.856V6.152C10.463 4.332 20.925 2.54 31.38.692z","fill":"#207245"}}),_c('path',{attrs:{"d":"M35.429 8.19h22.492v42.94H35.43v-4.09h5.453v-4.77h-5.453v-2.727h5.453v-4.771h-5.453v-2.726h5.453v-4.771h-5.453v-2.727h5.453v-4.771h-5.453v-2.726h5.453V12.28h-5.453V8.19z","fill":"#fff"}}),_c('path',{attrs:{"d":"M43.608 12.28h9.542v4.77h-9.542v-4.77z","fill":"#207245"}}),_c('path',{attrs:{"d":"M20.189 18.666c1.54-.11 3.087-.205 4.634-.28-1.817 3.732-3.65 7.456-5.5 11.172 1.875 3.816 3.79 7.606 5.67 11.423-1.64-.094-3.28-.199-4.92-.314-1.159-2.842-2.57-5.589-3.401-8.56-.927 2.767-2.25 5.377-3.312 8.09-1.493-.02-2.986-.081-4.479-.143 1.752-3.428 3.442-6.884 5.248-10.292-1.533-3.51-3.217-6.952-4.798-10.442 1.5-.089 2.999-.177 4.498-.259 1.015 2.665 2.126 5.296 2.965 8.03.9-2.897 2.242-5.624 3.395-8.425z","fill":"#fff"}}),_c('path',{attrs:{"d":"M43.608 19.777h9.542v4.771h-9.542v-4.771zm0 7.497h9.542v4.772h-9.542v-4.771zm0 7.498h9.542v4.771h-9.542v-4.771zm0 7.497h9.542v4.772h-9.542v-4.772z","fill":"#207245"}})])
          )
        }
      }
    